// extracted by mini-css-extract-plugin
export default {"wrap-body":"AutoBillPayPopup_wrap-body__G69u3"};